import { Divider } from '@nextui-org/react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { BellRouteIcon, ChatWriteIcon } from '../../../assets';
import ZIndexLayers from '../../../services/ZIndexLayers';
import { ThemeProp } from '../../../theme/Themes';

// We add the safe area inset to the bottom offset to properly position the tabs component on iPhone PWA.
export const bottomNavHeight = 'calc(4rem + env(safe-area-inset-bottom, 1rem))';

export const Container = styled.div`
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  bottom: 0;
  display: none;
  flex-wrap: nowrap;
  height: ${bottomNavHeight};
  justify-content: space-between;
  left: 0;
  // We add the safe area inset to the bottom offset to properly position the tabs component on iPhone PWA.
  padding: 0 1rem env(safe-area-inset-bottom, 1rem) 1rem;
  position: fixed;
  right: 0;
  vertical-align: middle;
  z-index: ${ZIndexLayers.navbar};
  box-shadow: ${(props: ThemeProp) => props.theme.shadows.bottomNavBar};

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    display: flex;
  }
`;

export const Line = styled(Divider)`
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export const Link = styled(NavLink)`
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c500};
  display: flex;
  flex-direction: column;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xxs};
  gap: 0.1rem;
  margin: auto;
  stroke: ${(props: ThemeProp) => props.theme.colors.greyscale.c500};

  &.active {
    color: ${(props: ThemeProp) => props.theme.colors.white};
    stroke: ${(props: ThemeProp) => props.theme.colors.white};
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const StyledChatWriteIcon = styled(ChatWriteIcon)`
  height: 1.2rem;
  width: 1.4rem;
  margin-bottom: 2px;
`;

export const StyledBellRouteIcon = styled(BellRouteIcon)`
  height: 1.5rem;
  width: 1.4rem;
`;

export const DotContainer = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: 0.5rem;
  width: 0.5rem;
  position: absolute;
  right: 1px;
  top: 1px;
`;

export const UnreadDotIndicator = styled.div`
  background: ${(props: ThemeProp) => props.theme.colors.main.c600};
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  border-radius: 4px;
  height: 100%;
  width: 100%;
`;

export const NotificationIconContainer = styled.div`
  display: flex;
  position: relative;
`;
